import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'lum-location-warehouse-group-filter',
  templateUrl: './location-warehouse-group-filter.component.html',
  styleUrls: ['./location-warehouse-group-filter.component.scss'],
})
export class LocationWarehouseGroupFilterComponent {
  @Output()
  filterUpdateEvent = new EventEmitter<{
    [param :string] :string | string[];
  }>();

  filter :{
    [param :string] :string | string[];
  } = {
    label: '',
  };

  onFilterUpdate(value :any, key :string) :void {
    this.filter = {
      ...this.filter,
      [key]: value.toString(),
    };

    this.filterUpdateEvent.emit(this.filter);
  }
}
